import { render } from "./SubmissionDetailsModal.vue?vue&type=template&id=9c41b44e&scoped=true"
import script from "./SubmissionDetailsModal.vue?vue&type=script&lang=js"
export * from "./SubmissionDetailsModal.vue?vue&type=script&lang=js"

import "./SubmissionDetailsModal.vue?vue&type=style&index=0&id=9c41b44e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c41b44e"]])

export default __exports__